import { listOptions } from '@/febos/servicios/api/opciones.api';
import { uniqueByField } from '@/utils';

async function fetchAttachmentsConfig(formName) {
  const { data: { opciones } } = await listOptions({
    grupoOpcion: `${formName.toLowerCase()}-attachments`,
    deshabilitado: 'no',
    orden: '+orden',
  });

  const opts = uniqueByField(opciones, 'valor').map((opt) => {
    let extra;
    try {
      extra = JSON.parse(opt.extra);
    } catch { /**/ }

    return {
      id: opt.opcionId,
      value: opt.valor,
      label: opt.descripcion,
      order: opt.orden,
      extra: extra || {},
    };
  });

  return {
    options: opts,
    selectors: opts
      .filter((opt) => !!opt.extra)
      .map((opt) => ({ ...opt, ...opt.extra, index: opt.order }))
  };
}

/**
 * Obtiene la configuración de los adjuntos para un formulario
 * @param {string} formName Nombre del formulario
 * @returns {Promise<{options: Array, selectors: Array}>}
 * @throws {Error}
 */
export async function getAttachmentsConfig(formName) {
  if (!formName) return { options: [], selectors: [] };

  try {
    return await fetchAttachmentsConfig(formName);
  } catch (e0) {
    console.error('Error trying to fetch attachments config (attempt 1)', e0);
    try {
      return await fetchAttachmentsConfig(formName);
    } catch (e1) {
      console.error('Error trying to fetch attachments config (attempt 2)', e0);
      throw e1;
    }
  }
}
